import React from 'react';
import { Switch } from 'antd';

export default function SiloContactShadows(props) {
    return (
        <div style={ props.absolutePosition ? { position:"absolute", right:"2%", top:"1%" } : { }} className= {`${props.absolutePosition ? "switch-flex" : "switch-flex-presets"}`}>
            <span className={`manrope f-14 black ${props.absolutePosition ? "" : "silo-heading-main"}`}>
                Contact Shadows
            </span>
            <Switch style={{marginLeft: 8}} checked={props.dropShadows} disabled={ props.shadowsRig|| !props.isFloorItem}  onChange={props.onChangeDropShadows} />
        </div>
    )
}
